import React from 'react';
import './ErrorDialog.css';
import { FaExclamationTriangle, FaTimes, FaRedo, FaTrash, FaPlane } from 'react-icons/fa';

const ErrorDialog = ({
  isOpen,
  onClose,
  onRetry,
  onDelete,
  onAirplaneMode,
  errorMessage,
  itemDescription,
  isBatch = false,
  failedFiles = [],
  errorGroups = {}
}) => {
  if (!isOpen) return null;

  const handleRetry = () => {
    onRetry();
    onClose();
  };

  const handleDelete = () => {
    onDelete();
    onClose();
  };

  const handleAirplaneMode = () => {
    if (onAirplaneMode) {
      onAirplaneMode();
    }
    onClose();
  };

  return (
    <div className="error-dialog-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="error-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="error-dialog-header">
          <div className="error-dialog-icon">
            <FaExclamationTriangle size={24} />
          </div>
          <h3>Erreur de traitement</h3>
          <button className="error-dialog-close" onClick={onClose}>
            <FaTimes size={20} />
          </button>
        </div>

        <div className="error-dialog-content">
          {itemDescription && (
            <p className="error-dialog-item">{itemDescription}</p>
          )}
          <p className="error-dialog-message">{errorMessage}</p>
          
          {isBatch && failedFiles.length > 0 && (
            <div className="error-dialog-details">
              <details>
                <summary>Détails des erreurs ({failedFiles.length} fichiers)</summary>
                <ul className="error-dialog-file-list">
                  {failedFiles.map(({ file, error }, index) => (
                    <li key={index}>
                      <span className="error-dialog-filename">{file.name}</span>
                      <span className="error-dialog-error">{error.message || 'Erreur inconnue'}</span>
                    </li>
                  ))}
                </ul>
              </details>
            </div>
          )}
        </div>

        <div className="error-dialog-footer">
          <div className="error-dialog-actions">
            <button
              className="error-dialog-button error-dialog-delete"
              onClick={handleDelete}
            >
              <FaTrash size={16} />
              <span>Supprimer</span>
            </button>
            {onAirplaneMode && (
              <button
                className="error-dialog-button error-dialog-airplane"
                onClick={handleAirplaneMode}
                style={{
                  backgroundColor: '#ff9800',
                  color: 'white'
                }}
              >
                <FaPlane size={16} />
                <span>Mode avion</span>
              </button>
            )}
            <button
              className="error-dialog-button error-dialog-retry"
              onClick={handleRetry}
              autoFocus
            >
              <FaRedo size={16} />
              <span>Réessayer</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorDialog;